import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "v-select-item sub"
}
const _hoisted_2 = ["onClick"]
const _hoisted_3 = {
  key: 0,
  class: "v-select-item sub"
}
const _hoisted_4 = ["onClick"]

import { computed, reactive, ref, watch } from 'vue';
import { useRepliesStore } from '@/stores/replies';
import { useDialogStore } from '@/stores/dialogs';
import VSelect from './VSelect.vue';
import VAuthInput from './VAuthInput.vue'
import AddIcon from './icons/other/AddIcon.vue';
import SearchIcon from './icons/other/SearchIcon.vue';
import VCollapse from './VCollapse.vue';
import CreateAutoReplyDialog from './dialogs/CreateAutoReplyDialog.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'VReplySetSelectStats',
  props: {
    word: null,
    ignoreItems: null
  },
  setup(__props: any) {

const props = __props as { word: string, ignoreItems: any[] }



const selectRef = ref()
const dialogStore = useDialogStore()
const onAddClick = () => {
  dialogStore.open(CreateAutoReplyDialog, { word: props.word })
  selectRef.value.close()
}

const onItemClick = (e: MouseEvent, item: any) => {
  dialogStore.open(CreateAutoReplyDialog, { item, word: props.word })
  selectRef.value.close()
}

const repliesStore = useRepliesStore()
const searchValue = ref("")
const searching = computed(() => !!searchValue.value)

const collapseRef = reactive<any>([ null, null ])
watch(searchValue, () => {
  for (let item of collapseRef) {
    if (!item) continue
    item.open()
  }
})

const ignoreIds = computed(() => {
  const set = new Set<number>()
  if (props.ignoreItems) {
    for (let item of props.ignoreItems) {
      set.add(item.id)
    }
  }
  return set
})

const keywordBased = computed(() => {
  const arr = repliesStore.replies.filter(item => !ignoreIds.value.has(item.id) && item.replies_set_mode_id === 1)
  if (!searching.value) return arr
  const val = searchValue.value.toLowerCase()
  return arr.filter(item => item.name.toLowerCase().includes(val))
})

const assetBased = computed(() => {
  const arr = repliesStore.replies.filter(item => !ignoreIds.value.has(item.id) && item.replies_set_mode_id === 2)
  if (!searching.value) return arr
  const val = searchValue.value.toLowerCase()
  return arr.filter(item => item.name.toLowerCase().includes(val))
})

const hasKeywordBased = computed(() => !!repliesStore.replies.find(item => !ignoreIds.value.has(item.id) && item.replies_set_mode_id === 1))
const hasAssetBased = computed(() => !!repliesStore.replies.find(item => !ignoreIds.value.has(item.id) && item.replies_set_mode_id === 2))

const defaultOpened = computed(() => assetBased.value.length + keywordBased.value.length < 10)


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(VSelect, {
    ref_key: "selectRef",
    ref: selectRef,
    small: "",
    "menu-class": "template-select-menu",
    "mobile-close": ""
  }, {
    default: _withCtx(() => [
      _createTextVNode("Add")
    ]),
    top: _withCtx(() => [
      _createVNode(VAuthInput, {
        modelValue: searchValue.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchValue).value = $event)),
        icon: SearchIcon,
        placeholder: "Search",
        class: "light search template-select-input",
        autofocus: "",
        clearable: ""
      }, null, 8, ["modelValue"]),
      (!_unref(searching))
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "template-select-add-button",
            style: {"minWidth":"210px"},
            onClick: onAddClick
          }, [
            _createVNode(AddIcon),
            _createTextVNode(" Add Reply Set ")
          ]))
        : _createCommentVNode("", true),
      (_unref(hasKeywordBased))
        ? (_openBlock(), _createBlock(VCollapse, {
            key: 1,
            ref: r => collapseRef[0] = r,
            opened: _unref(defaultOpened),
            title: "KEYWORD BASED"
          }, {
            default: _withCtx(() => [
              (_unref(keywordBased).length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_unref(searching)? "Nothing found": "No blocklists yet"), 1))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(keywordBased), (item) => {
                return (_openBlock(), _createElementBlock("button", {
                  class: "v-select-menu__button",
                  onClick: ($event: any) => (onItemClick($event, item))
                }, _toDisplayString(item.name), 9, _hoisted_2))
              }), 256))
            ]),
            _: 1
          }, 8, ["opened"]))
        : _createCommentVNode("", true),
      (_unref(hasAssetBased))
        ? (_openBlock(), _createBlock(VCollapse, {
            key: 2,
            ref: r => collapseRef[1] = r,
            opened: _unref(defaultOpened),
            title: "ASSET BASED"
          }, {
            default: _withCtx(() => [
              (_unref(assetBased).length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_unref(searching)? "Nothing found": "No templates yet"), 1))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(assetBased), (item) => {
                return (_openBlock(), _createElementBlock("button", {
                  class: "v-select-menu__button",
                  onClick: ($event: any) => (onItemClick($event, item))
                }, _toDisplayString(item.name), 9, _hoisted_4))
              }), 256))
            ]),
            _: 1
          }, 8, ["opened"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 512))
}
}

})